import { post } from '../http';

export const save = async data => post('feedback/save', data);
